/**
 * PerformanceInsightsPage — role-aware entry point for "PMS > Performance
 * Insights". Managers see their direct reports (`TeamInsightsDashboard`
 * default); Admin/HR see the same dashboard scoped to every active employee
 * org-wide, via the admin predictions/KPI-averages endpoints.
 */

import React from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../../store/Store";
import { adminAllPredictionsUrl, orgKpiAveragesUrl } from "../../../Service/Apis";
import TeamInsightsDashboard from "./TeamInsightsDashboard";

const PerformanceInsightsPage: React.FC = () => {
  const selectedRole = useSelector((state: RootState) => state.auth.selectedRole);
  const isAdminOrHr = selectedRole === "Admin" || selectedRole === "HR";

  if (isAdminOrHr) {
    return (
      <TeamInsightsDashboard
        predictionsUrl={adminAllPredictionsUrl}
        kpiAveragesUrl={orgKpiAveragesUrl}
        description="AI-assisted performance insights for all active employees, based on predicted vs. actual manager ratings and supporting HR/attendance/utilization data."
        emptyMessage="No performance insight data is available yet."
      />
    );
  }

  return <TeamInsightsDashboard />;
};

export default PerformanceInsightsPage;
